import getFlags from '../flagGetter';
import {Locale} from '../RootProvider/LocaleContext';

export const getLocalesWithDashboard = (): Locale[] => {
  const localesWithDashboard = [Locale.uk];

  if (getFlags().NL_DASHBOARD) {
    localesWithDashboard.push(Locale.nl);
  }

  return localesWithDashboard;
};

export const isLocaleWithDashboard = (locale: Locale): boolean => getLocalesWithDashboard().includes(locale);

export const getLocalesWithDocumentUpload = (): Locale[] => [Locale.uk, Locale.nl];

export const isLocaleWithDocumentUpload = (locale: Locale): boolean => getLocalesWithDocumentUpload().includes(locale);
